export default {
  namespaced: true,

  state: () => ({
    loading: false,
    items: [],
    activeIndex: 0,
    currentProductSize: {},
  }),

  getters: {
    items: (state) => state.items,
    activeIndex: (state) => state.activeIndex,
    currentItem: (state) => state.items[state.activeIndex] ?? [],
    currentItemProducts: (_, getters) => getters.currentItem.models ?? [],
    selectedProducts: (_, getters) => getters.currentItemProducts.filter((it) => it.selected),
    selectedProductsWoSize: (_, getters) => getters.selectedProducts.filter((it) => !it.selectedSku),

    selectedProductsBasePrice: (_, getters) => getters.selectedProducts
      .reduce((acc, it) => acc + it.basePrice, 0) ?? 0,

    firstProductWoSizeIndex: (_, getters) => getters.currentItemProducts
      .findIndex((it) => it.id === getters.selectedProductsWoSize[0]?.id),

    currentProductSize: (state) => state.currentProductSize,
  },

  actions: {
    async fetchPromoKits({ commit }, { productId, selectedSize }) {
      commit('setLoading', true);

      try {
        const promoKits = await this.$apiBFF.fetchProductPromoKits({ productId });

        commit('setItems', promoKits);

        if (selectedSize) {
          commit('setCurrentProductSize', {
            productId,
            selectedSize,
          });
          commit('setProductSelectedSize', { productId, selectedSize });
        }
      } finally {
        commit('setLoading');
      }
    },
  },

  mutations: {
    setLoading: (state, value) => {
      state.loading = !!value;
    },

    setItems: (state, items = []) => {
      state.items = items;
    },

    setCurrentProductSize: (state, size) => {
      state.currentProductSize = size;
    },

    setActiveIndex: (state, value) => {
      let index = value;

      if (value < 0) {
        index = state.items.length - 1;
      } else if (value >= state.items.length) {
        index = 0;
      }

      state.activeIndex = index;
    },

    setProductSelectedSize: (state, { productId, selectedSize }) => {
      const newItems = state.items.map((item) => ({
        ...item,
        models: item.models.map((model) => {
          if (model.id === productId) {
            return {
              ...model,
              selectedSku: Object.keys(selectedSize).length ? { ...selectedSize } : null,
            };
          }
          return model;
        }),
      }));

      state.items = newItems;
    },

    toggleOpenSizes: (state, value) => {
      const newItems = state.items.map((item) => ({
        ...item,
        models: item.models.map((model) => ({
          ...model,
          isOpenSku: !!value,
        })),
      }));

      state.items = newItems;
    },

    toggleProductOpenSizes: (state, { productId, value }) => {
      const newItems = state.items.map((item) => ({
        ...item,
        models: item.models.map((model) => {
          if (model.id === productId) {
            return {
              ...model,
              isOpenSku: !!value,
            };
          }
          return model;
        }),
      }));

      state.items = newItems;
    },
  },
};
